<template>
    <v-col cols="12" sm="12" style="background-color: white">
        <v-container class="app-container">
            <home-title :title="$t('partners')"></home-title>

            <v-slide-group multiple show-arrows>
                <v-slide-item
                    v-for="partner in partnersInfo"
                    :key="partner.id"
                >
                    <a :href="partner.link" target="_blank" rel="nofollow">
                        <v-img
                            :src="partner.image"
                            contain
                            class="ma-9"
                            width="150"
                            height="150"
                        ></v-img>
                    </a>
                </v-slide-item>
            </v-slide-group>
        </v-container>
    </v-col>
</template>

<script>
    import HomeTitle from './HomeTitle';
    import Partners from '../../../app-front/mixins/Partners';

    export default {
        name: 'HomePartners',
        mixins: [Partners],
        components: {
            HomeTitle,
        }
    }
</script>

<style scoped>

</style>
